
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsWifi = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M.92 11.33A23.885 23.885 0 0 1 16 6a23.89 23.89 0 0 1 15.08 5.33l-1.675 2.074A21.237 21.237 0 0 0 16 8.667a21.235 21.235 0 0 0-13.405 4.737L.92 11.329zM16 12.666c4.125 0 7.915 1.441 10.892 3.848l-1.676 2.074A14.61 14.61 0 0 0 16 15.332c-3.49 0-6.697 1.22-9.216 3.256l-1.676-2.074A17.263 17.263 0 0 1 16 12.667zm0 6.666c2.539 0 4.87.887 6.703 2.368l-1.676 2.075A7.97 7.97 0 0 0 16 22a7.967 7.967 0 0 0-5.027 1.776l-1.676-2.075A10.638 10.638 0 0 1 16 19.333z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\" opacity=\"1\">\r\n        <g>\r\n            <g>\r\n                <path d=\"M0 0L32 0 32 32 0 32z\" transform=\"translate(-1372 -456) translate(1372 456)\"/>\r\n                <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M.92 11.33C5.185 7.873 10.51 5.991 16 6c5.713 0 10.96 1.996 15.08 5.33l-1.675 2.074C25.614 10.332 20.88 8.659 16 8.667c-5.079 0-9.741 1.773-13.405 4.737L.92 11.329zM16 12.666c4.125 0 7.915 1.441 10.892 3.848l-1.676 2.074c-2.607-2.111-5.861-3.261-9.216-3.256-3.49 0-6.697 1.22-9.216 3.256l-1.676-2.074C8.188 14.02 12.035 12.66 16 12.667zm0 6.666c2.539 0 4.87.887 6.703 2.368l-1.676 2.075C19.605 22.624 17.83 21.997 16 22c-1.904 0-3.653.665-5.027 1.776l-1.676-2.075c1.896-1.534 4.263-2.371 6.703-2.368z\" transform=\"translate(-1372 -456) translate(1372 456)\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-wifi.da89da8f3abdd9da70008e7b7b3eac84.svg"),
        {
          React: SvgIconsWifi,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      